import React from 'react';
import { Link } from 'react-router-dom';
import { FaLock, FaHome, FaArrowLeft } from 'react-icons/fa';

const Unauthorized = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-red-600 to-red-800 p-8 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6">
              <FaLock className="h-8 w-8 text-red-600" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Access Denied</h1>
            <p className="text-red-100">You don't have permission to access this page</p>
          </div>

          {/* Content */}
          <div className="p-8 text-center">
            <div className="mb-6">
              <p className="text-gray-600 mb-4">
                You need special permissions to access this page. If you believe this is an error, 
                please contact your system administrator.
              </p>
              
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-yellow-800 text-sm">
                  <strong>Note:</strong> Admin pages require specific permissions based on your role.
                </p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4">
              <Link
                to="/"
                className="inline-flex items-center justify-center w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 font-medium"
              >
                <FaHome className="h-5 w-5 mr-2" />
                Go to Homepage
              </Link>
              
              <Link
                to="/admin"
                className="inline-flex items-center justify-center w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors duration-200 font-medium"
              >
                <FaArrowLeft className="h-5 w-5 mr-2" />
                Back to Admin Dashboard
              </Link>
            </div>

            {/* Admin Contact Info */}
            <div className="mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">
                Need access? Contact your administrator:
              </p>
              <p className="text-sm text-gray-800 font-medium mt-1">
                admin@brasotech.com
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            Brasotech Investments Limited
          </p>
          <p className="text-xs text-gray-500 mt-1">
            
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;